import { Controller } from 'stimulus';
import 'img-comparison-slider';

class BeforeAfterController extends Controller {
  //
}

BeforeAfterController.targets = [
  //
];

export default BeforeAfterController;
